import { css } from "@styled-system/css";

export const filterClass = css({
	display: "flex",
	gap: "8",
	my: "16",
});
